import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { Divider, Header, Image, Container, Table, Button } from 'semantic-ui-react';
import { Container } from 'semantic-ui-react';
// import { Link } from 'react-router-dom';


class Info extends Component {
  // state = { unique_visitors: 0, impressions: 0, page_views: 0 }
  // stats = () => {
  //   const { stats } = this.props;
  // }

  render() {
    // let { stats } = this.state;
    return(
      <Container>
        <h1>About This App</h1>

        <h3>Binomial Distribution</h3>
        <p>Many statistical problems can be defined in terms of a binomial distribution. A classic example is that of the rolls of a die. If I have a ten sided die, it is obvious that the odds of me rolling, say, a one is 10% on any given roll. But what are the odds that I'll get a one if I roll the die ten times, or a hundred times? To answer the question in a useful way, we have to expand the scope of the question. A better way to frame the question is "If I have a one-in-X chance of getting my desired outcome per trial, what are the odds of getting this outcome one time, two times, three times, etc, over Y trials?" The binomial distribution equations give us the answers to these types of questions. </p>

        <h3>Background</h3>
        <p>I built this (initially in Excel) when working as an online media planner. I found that smaller websites could always tell me their monthly unique visitors and their page views, but that many didn't use an ad delivery system that could cap impressions per user. To responsibly place a media buy for ad impressions on these sites, I needed a way to estimate how many site visitors would see an ad how many times so that I could tailor a buy to have its peak in range of the advertiser's effective frequency for the ad.</p>
        {/* { stats && <Button fluid basic onClick={this.clearFilter}>Clear Filter</Button> } */}
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  const stats = state.stats;
  // const stats = [ ...new Set(stats.map(stat => stat.value))]
  return { stats };
}

export default connect(mapStateToProps)(Info);



// WEBPACK FOOTER //
// ./src/components/Info.js